module.exports = __webpack_public_path__ + "static/media/smille.117a405f.svg";